import React from 'react';
import styles from './DemoBanner.module.css';

export default function DemoBanner() {
  if (process.env.REACT_APP_DEMO_MODE !== 'true') return null;

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <span className={styles.icon} aria-hidden="true">🎬</span>
      <span className={styles.text}>
        <strong>Mode Démo</strong> — Données fictives, actions désactivées
      </span>
      <span className={styles.separator}>•</span>
      <span className={styles.cta}>
        Pour une démo personnalisée :&nbsp;
        <a href="mailto:contact@sylink.fr?subject=Demande de d%C3%A9mo SYLink Pentest">
          contact@sylink.fr
        </a>
      </span>
    </div>
  );
}
